import { Container } from '@moonpig/launchpad-components'
import { system as s } from '@moonpig/launchpad-system'
import { styled } from '@moonpig/launchpad-utils'

export const StyledContainer = styled(Container)`
  max-height: 100vh;
  overflow-y: auto;  
  ${s({
    mx: 0,
  })}

  [data-testid='module-buttons'] {
    position: sticky;
    bottom: 0;
    z-index: 3;
    width: auto;
    ${s({
      mx: { xs: -6, md: -8 },
      px: { xs: 6, md: 8 },
      py: 6,
      borderTop: 1,
      borderColor: 'colorBorder03',
      boxShadow: 4,
      mb: 0,
      bgcolor: 'colorPrimary03',
    })}
  }
`

export const StyledProvidersLayout = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-height: 0;
  overflow: hidden;
`
